module.exports = __webpack_public_path__ + "static/img/inflatable-bag.18123d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/inflatable-bag.png
// module id = 6Eta
// module chunks = 2